import { Input } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { emailStepStore, validateEmail } from "@/entities/StepEmail/store/emailStepStore";
import { useFocusTrap } from "@mantine/hooks";
import {  IconExclamationCircle } from "@tabler/icons-react";
import { useState } from "react";


interface IStepEmailInputProps {
	handleNextButton: () => void;
}

export const StepEmailInput = ({ handleNextButton }: IStepEmailInputProps) => {
	const { t } = useTranslation();
	const email = emailStepStore((state) => state.email);
	const setEmail = emailStepStore((state) => state.setEmail);
	const focusTrapRef = useFocusTrap();
	const [currentEmail, setCurrentEmail] = useState(email || "");
	const [currentEmailError, setCurrentEmailError] = useState(false);

	const handleChangeEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value= e.currentTarget.value.trim();
		setCurrentEmail(value);
		const isValid = value.length>0 ? !!validateEmail(value) : true;

		setCurrentEmailError(!isValid);
		if(isValid || currentEmail.length>value.length) {
			setEmail(value);
		}

	};

	const handleBlurEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
		if(currentEmail.length>0) setEmail(currentEmail);
	};

	const handleEnter = (event: React.KeyboardEvent<HTMLInputElement>) => {
		if (event.key === "Enter") {
			handleNextButton();
		}
	};

	return (

		<Input
			ref={focusTrapRef}
			placeholder={t("common.email")}
			onBlur={handleBlurEmail}
			value={currentEmail}
			onChange={handleChangeEmail}
			required
			rightSection={
				currentEmailError && <IconExclamationCircle
					style={{ width: 20, height: 20 }}
					color="var(--mantine-color-error)"
				/>
			}
			onKeyDown={handleEnter}
			style={{
				width: "100%",
				marginBottom: 20,
				fontWeight: "bold"
			}}
		/>
	);
};
